const urlUtils = {
    getFullApiHostname() {
        return `https://${this.getApiHostname()}`;
    },

    getApiHostname() {
        const host = window.location.hostname;
        let port = window.location.port.length > 1 ? `:${window.location.port}` : '';

        if (host === 'localhost') {
            port = ':5001';
        }

        return `${host}${port}`;
    },

    getUrlQueryParameter(location, param) {
        const params = new URLSearchParams(location.search);
        return params.get(param);
    },

    /**
     * Validates a server-supplied redirect target before it is used for navigation.
     *
     * The API's RedirectTo is meant to be an app-relative path (ExceptionMiddleware.cs fills it
     * from RedirectException; CustomerDomainService.cs builds "/customer/{0}" or
     * "/search?input={0}"), but it is untrusted data flowing into a navigation sink and the
     * search variant interpolates raw user input, so it must not be trusted blindly.
     *
     * Returns the safe pathname+search+hash to navigate to, or null if the value resolves
     * anywhere other than this app's own origin — absolute cross-origin URLs,
     * protocol-relative "//evil.com", and javascript:/data: schemes (opaque origin) are refused.
     */
    toSameOriginPath(redirectTo) {
        try {
            const resolved = new URL(redirectTo, window.location.origin);
            if (resolved.origin !== window.location.origin) return null;
            if (resolved.protocol !== 'http:' && resolved.protocol !== 'https:') return null;
            return `${resolved.pathname}${resolved.search}${resolved.hash}`;
        } catch {
            return null;
        }
    },

    /**
     * Validates a navigation target that is legitimately allowed to be cross-origin (e.g. the
     * external VON OAuth authorization link the backend hands back), so toSameOriginPath would
     * wrongly reject it.
     *
     * Only the scheme is constrained: http/https pass, everything else (javascript:, data:,
     * vbscript: ...) is refused, which closes the script-execution vector while still permitting
     * the intended redirect to an external identity provider on any host.
     */
    toSafeHttpUrl(url) {
        try {
            const parsed = new URL(url);
            if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return null;
            return parsed.href;
        } catch {
            return null;
        }
    }
};

export default urlUtils;
